import React, { useRef, useEffect} from "react";
import { useHistory } from "react-router-dom";

//component
import ProductCard from "../ProductCard/ProductCard";

//style
import { ProductCardWrapper } from "../ProductCard/ProductCard.style";
import { } from "../../styled/pages.style";
import { ProductsCol, ProductsRow } from '../../containers/Products/Products.style'
import {
    RelatedProductContainer,
    RelatedProductTitle,
    SeeMoreButtonContainer,
    SeeMoreButton,
} from "./RelatedProduct.style";

//utils
import { CURRENCY } from "../../helper/constant";
import t from '../../i18n/translate';
import { logPageView, logViewItem } from "../../services/googleAnalytics";

const RelatedProduct = ({ props, deviceType, isExtra, isCloseSEO = false, onSeenProduct }) => {
    let history = useHistory();

    const itemsRefs = useRef({});

    useEffect(() => {
        if (!props.relatedProducts.length) return;
        // const idsOnly = props.relatedProducts.map(product => product.item_id)
        // const jsonIds = JSON.stringify(idsOnly)
        // localStorage.setItem("viewProductListRelated", jsonIds)

        const observer = new IntersectionObserver(
        (entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    const id = entry.target.dataset.id;
                    if (onSeenProduct) {
                    onSeenProduct(id);
                    }
                    observer.unobserve(entry.target);
                }
            });
        },{
            root: null,
            rootMargin: "0px",
            threshold: 0
        }
        );

        // wire up the observer
        Object.values(itemsRefs.current).forEach(node => {
        if (node) observer.observe(node);
        });

        return () => observer.disconnect();
    }, [props.relatedProducts, onSeenProduct]);

    const handleSeeMoreButton = () => {
      props.getRelatedProducts({
        product_id: props.modalData.item_id,
        page: props.relatedProduct_page + 1,
        limit: props.relatedProduct_limits
      })
        props.changeRelatedProductPage({
        page: props.relatedProduct_page + 1
      })
    }
    return (
        <>
        {props.relatedProducts.length > 0 &&
            <RelatedProductContainer>
                    <RelatedProductTitle>{t("product_info_related_product")}</RelatedProductTitle>
                <ProductsRow id={"productList"}>
                    {
                    props.relatedProducts.map((item, index) => (
                        <ProductsCol 
                            key={index} 
                            data-id={item.item_id}
                            ref={el => itemsRefs.current[item.item_id] = el}
                        >
                            <ProductCardWrapper>
                                <ProductCard
                                title={item.name}
                                description={item.about_item}
                                image={item.default_image_url}
                                weight={
                                    item.store_items_price_types[0].name !== " "
                                    ? item.store_items_price_types[0].name
                                    : item.store_items_price_types[0].weight +
                                        " " +
                                        item.store_items_price_types[0].weight_unit
                                }
                                outOfStock={
                                    !item.store_items_price_types[0].available_quantity
                                }
                                // weight={item.store_items_price_types[0].name}
                                currency={CURRENCY}
                                price={item.store_items_price_types[0].mrp}
                                salePrice={item.store_items_price_types[0].price}
                                isSameDay={item.same_day}
                                discountInPercent={item.discountInPercent}
                                data={item}
                                deviceType={deviceType}
                                onClick={() => {
                                    if (props.cartType === "express") {
                                    //   handleQuickViewModal(item, deviceType, index)
                                    } else {
                                    logPageView(`/product/${item.item_ref_id}`)
                                    logViewItem(item,(`/product/${item.item_ref_id}`))
                                    history.push(`/product/${item.item_ref_id}`);
                                    window.scrollTo(0, 0)
                                    }
                                }}
                                onCartClick={() => {
                                    document.getElementById("joinBTn").click();
                                    window.trigger = "add to cart"
                                }}
                                promo={item.promo ? 1 : 0}
                                promoPrice={item.promo ? item.promo_price : null}
                                promoStartDate={item.promo ? item.promo_start_date : null}
                                promoEndDate={item.promo ? item.promo_end_date : null}
                                brandId={item.brand_id === 0 || item.brand_id === null ? 0 : item.brand_id}
                                brands={props.brands}
                                loading={props.loading}
                                page={props.page}
                                productCode={item.product_code}
                                isExtra={isExtra}
                                isCloseSEO={isCloseSEO}
                                />
                                {/* </Fade> */}
                            </ProductCardWrapper>
                        </ProductsCol>
                    ))}
                    {props.relatedProduct_page < props.total_relatedProduct_page &&
                        <ProductsCol key='see_more'>
                            <SeeMoreButtonContainer>
                                <SeeMoreButton onClick={handleSeeMoreButton}>{t("product_info_see_more")}</SeeMoreButton>
                            </SeeMoreButtonContainer>
                        </ProductsCol>
                    }
                </ProductsRow>
            </RelatedProductContainer>
        }</>
    )
}
export default RelatedProduct;